"use client";

import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import Link from "next/link";
import { Navigation } from "swiper/modules";
interface ImageSliderProps {
  images: { url: string; link: string }[];
}

const ImageSlider: React.FC<ImageSliderProps> = ({ images }) => {
  console.log(images);
  const sliderRef = useRef<any>(null);
  return (
    <div
      ref={sliderRef}
      className="relative h-full overflow-hidden custom-slider"
    >
      <Swiper modules={[Navigation]} speed={600} navigation={true}>
        {images.map((image, index) => (
          <SwiperSlide className="relative" key={`imageslider-${index}`}>
            {image.link?.length > 0 ? (
              <Link
                key={`section-${index}-link-${index}`}
                target="_blank"
                href={image.link}
                className="relative w-full"
                aria-label={`Billede`}
              >
                <img
                  className="object-cover w-full"
                  src={image.url}
                  alt={`Image`}
                />
              </Link>
            ) : (
              <img
                key={`section-${index}-image-${index}`}
                className="object-cover w-full"
                src={image.url}
                alt={`Image`}
              />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageSlider;
